<template>
	<PopupRouterViewApprovalDetail label="Purchase Order Input" @approveMethod="submitAction" :showApproveButton="isAllowSubmit"
		approveButtonTitle="Submit Request" approveButtonVariant="success" @rejectMethod="saveAction"
		:showRejectButton="isAllowSaveDraft" rejectButtonTitle="Save As Draft" rejectButtonVariant="danger"
		:showRevisionButton="false" :showApprovalHistoryButton="false" :showLeftIcon="true" :isBusy="isBusy">

		<b-card header="Purchase Order" class="mb-3">
			<b-row>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Purchase Order Number"
						v-if="!model.isManualNumber" :model="purchaseOrderNumber"/>
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Purchase Order Number"
						v-if="model.isManualNumber && model.mainRecordId != null" :model="purchaseOrderNumber"/>
					<app-input-textbox label-cols-lg="12" size="sm" label="Purchase Order Number"
   						v-if="model.isManualNumber && model.mainRecordId == null" :model.sync="purchaseOrderNumber" @change="updateData"/>
					<app-input-combobox-autocomplete :options="purchaseRequests" optionsLabel="purchaseRequestNumber"
						optionsKey="id" label-cols-lg="12" label="Purchase Request Number"
						id="fieldset-purchase-request" size="sm" :model.sync="model.purchaseRequestId"
						:selected="model.purchaseRequest != null ? model.purchaseRequest.purchaseRequestNumber : ''"
						@input="getPurchaseRequests" @change="updatePurchaseRequest" :isRequired="true"
						:isEditable="isEditRequest" :isSelectMethodExists="true" @onSelectMethod="updatePurchaseRequest"
						:state="validateState('purchaseRequestNumber')"
						:errorMessage="getErrorMessage(errorMessage.purchaseRequestNumber, 'purchaseRequestNumber')" />
					<app-input-datepicker id="fieldset-purchase-order-date" label-cols-lg="12"
						label="Purchase Order Date" size="sm" :model.sync="model.purchaseOrderDate"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						:isRequired="true" @change="updateData" :isEditable="true" :min="minDate"
						:state="validateState('purchaseOrderDate')"
						:errorMessage="getErrorMessage(errorMessage.purchaseOrderDate, 'purchaseOrderDate')" />
					<app-input-datepicker id="fieldset-delivery-date-request" label-cols-lg="12"
						label="Delivery Date Request" size="sm" :model.sync="model.deliveryDateRequest"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						:isRequired="true" @change="updateDeliveryDate()" :isEditable="true" :min="minDate"
						:state="validateState('deliveryDateRequest')"
						:errorMessage="getErrorMessage(errorMessage.deliveryDateRequest, 'deliveryDateRequest')" />
					<app-input-textarea id="fieldset-purpose" label-cols-lg="12" label="Purpose"
						label-for="input-purpose" size="sm" :model.sync="model.purpose" @change="updateData"
						:isEditable="true" />
					<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark"
						size="sm" :model.sync="model.remark" @change="updateData" :isEditable="true" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="vendors" optionsLabel="code" optionsKey="id"
						label-cols-lg="12" label="Vendor" id="fieldset-vendor" size="sm" :model.sync="model.vendorId"
						:selected="model.vendor != null ? model.vendor.code : ''" @input="getVendors"
						@change="updateData" :isRequired="true" :isEditable="true" :isSelectMethodExists="true"
						@onSelectMethod="updateVendor" :state="validateState('vendorId')"
						:errorMessage="getErrorMessage(errorMessage.vendorId, 'vendorId')" />
					<app-input-textbox label-cols-lg="12" size="sm" label="Contact Person"
						:model="(model.vendor != null) ? model.vendor.contactPerson : null" :isEditable="false" />
					<app-input-textbox id="fieldset-quotation-number" label-cols-lg="12" label="Quotation Number"
						label-for="input-quotation-number" size="sm" :model.sync="model.quotationNumber"
						@change="updateData" :isEditable="true" />
					<app-input-datepicker id="fieldset-quotation-date" label-cols-lg="12" label="Quotation Date"
						size="sm" :model.sync="model.quotationDate"
						:date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"
						@change="updateData" :isEditable="true" />

					<app-input-textbox id="fieldset-ppn" label-cols-lg="12" label="Ppn" label-for="input-ppn" size="sm"
						:model.sync="model.ppn" :isEditable="false" />
				</b-col>

			</b-row>
		</b-card>
		
		<b-card class="mb-3">
			<b-row>
				<b-col cols="12" lg="12">
					<app-table-input title="Purchase Order Detail" :bordered="true" :items="purchaseOrderDetails"
						:fields="fieldsPurchaseOrderDetail" :busy="isDataLoading"
						:sort-by.sync="sortByPurchaseOrderDetail" :sort-desc.sync="sortDescPurchaseOrderDetail" small
						responsive @editButtonMethod="editRowDataPurchaseOrderDetail"
						@deleteButtonMethod="deleteRowDataPurchaseOrderDetail"
						@showPopupAddMethod="addDataPurchaseOrderDetail()"
						@showPopupUploadMethod="showPopupUploadPurchaseOrderDetail()"
						@downloadMethod="downloadPurchaseOrderDetail()"
						@addFromClipboardMethod="addFromClipboardPurchaseOrderDetail()"
						@replaceFromClipboardMethod="replaceFromClipboardPurchaseOrderDetail()"
						:showActionButton="false" :showDeleteButton="false" :showAddButton="false"
						:showAddFromClipboardButton="false" :showReplaceFromClipboardButton="false"
						:showUploadButton="false" :showDownloadButton="false"
						:isDownloadBusy="isDownloadPurchaseOrderDetail">

						<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPurchaseOrderDetailFilter = !isShowPurchaseOrderDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->

						<template #top-row v-if="isShowPurchaseOrderDetailFilter">
							<b-th></b-th>
							<b-th stacked-heading="Part Code">
								<v-select id="input-purchase-order-detail-part-table" append-to-body label="partNumber"
									:options="parts" :value="filterPurchaseOrderDetail.partId" :reduce="item => item.id"
									v-model="filterPurchaseOrderDetail.partId" @search="getParts"
									:filterable="true"></v-select>
							</b-th>
							<b-th stacked-heading="Qty PO">
								<b-form-input id="input-purchase-order-detail-qty-po-table"
									v-model="filterPurchaseOrderDetail.qtyPo" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Price (Rp/Unit)">
								<b-form-input id="input-purchase-order-detail-price-unit-table"
									v-model="filterPurchaseOrderDetail.priceUnit" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Subtotal (Rp)">
								<b-form-input id="input-purchase-order-detail-subtotal-table"
									v-model="filterPurchaseOrderDetail.subtotal" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Ppn">
								<b-form-input id="input-purchase-order-detail-price-ppn-table"
									v-model="filterPurchaseOrderDetail.pricePpn" size="sm"></b-form-input>
							</b-th>
							<b-th stacked-heading="Amount">
								<b-form-input id="input-purchase-order-detail-amount-table"
									v-model="filterPurchaseOrderDetail.amount" size="sm"></b-form-input>
							</b-th>

							<b-th></b-th>
						</template>

						<template v-slot:cell(no)="row">
							{{ ((row.index + 1) + (purchaseOrderDetailPageSize * (currentPurchaseOrderDetailPage - 1)))
							}}
						</template>

						<template v-slot:table-busys>
							<div class="text-center my-2">
								<b-spinner class="align-middle text-primary"></b-spinner>
								<strong class="ml-2">Loading...</strong>
							</div>
						</template>

						<template v-slot:cell(part)="row">
							<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id"
								:id="'input-purchase-order-detail-part-' + row.index" label-cols-lg="12"
								label="Part Code" size="sm" :model.sync="row.item.partId"
								:state="validateState('partId')"
								:errorMessage="getErrorMessage(errorMessage.partId, 'partId')"
								@change="saveInputPurchaseOrderDetail(row.item)"
								:selected="row.item.part != null ? row.item.part.partNumber : ''" @input="getParts"
								:loading="isPartComboLoading" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(partName)="row">
							<app-input-textbox label-cols-lg="12" size="sm" label="Part Name"
								:model="row.item.part != null ? row.item.part.partName : ''" :isEditable="false" />
							<!-- {{ getPartName(row.item) }} -->
						</template>
						<template v-slot:cell(qtyPo)="row">
							<app-input-textbox :id="'input-purchase-order-detail-qty-po-' + row.index"
								label-cols-lg="12" label="Qty PO" size="sm" :model.sync="row.item.qtyPo"
								:state="validateState('qtyPo')"
								:errorMessage="getErrorMessage(errorMessage.qtyPo, 'qtyPo')"
								@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true"
								:thousandSeparator="true" />
						</template>
						<template v-slot:cell(uomPo)="row">
							<app-input-textbox label-cols-lg="12" size="sm" label="Uom Po"
								:model="(row.item.part != null) ? row.item.part.uomPoCode : null" :isEditable="false" />
						</template>
						<template v-slot:cell(priceUnit)="row">
							<app-input-textbox :id="'input-purchase-order-detail-price-unit-' + row.index"
								label-cols-lg="12" label="Price (Rp/Unit)" size="sm" :thousandSeparator="true"
								:model.sync="row.item.priceUnit" :state="validateState('priceUnit')"
								:errorMessage="getErrorMessage(errorMessage.priceUnit, 'priceUnit')"
								@change="recalculateSummary(row.item)" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(subtotal)="row">
							<app-input-textbox :id="'input-purchase-order-detail-subtotal-' + row.index"
								label-cols-lg="12" label="Subtotal (Rp)" size="sm" :thousandSeparator="true"
								:model.sync="row.item.subtotal" :state="validateState('subtotal')"
								:errorMessage="getErrorMessage(errorMessage.subtotal, 'subtotal')"
								@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(pricePpn)="row">
							<app-input-textbox :id="'input-purchase-order-detail-price-ppn-' + row.index"
								label-cols-lg="12" label="Ppn" size="sm" :model.sync="row.item.pricePpn"
								:thousandSeparator="true" :state="validateState('pricePpn')"
								:errorMessage="getErrorMessage(errorMessage.pricePpn, 'pricePpn')"
								@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true" />
						</template>
						<template v-slot:cell(amount)="row">
							<app-input-textbox :id="'input-purchase-order-detail-amount-' + row.index"
								label-cols-lg="12" label="Amount" size="sm" :thousandSeparator="true"
								:model.sync="row.item.amount" :state="validateState('amount')"
								:errorMessage="getErrorMessage(errorMessage.amount, 'amount')"
								@change="saveInputPurchaseOrderDetail(row.item)" :isEditable="false" :nolabel="true" />
						</template>


						<template v-slot:form-add-detail>
							<PurchaseOrderDetailInput :model="modelPurchaseOrderDetail"
								:openPopup="isShowPopupPurchaseOrderDetail" @resetMethod="resetModal"
								@addButtonMethod="addRowDataPurchaseOrderDetail" />
						</template>
						<template v-slot:upload-detail>
							<PurchaseOrderDetailUpload :openPopup="isShowPopupUploadPurchaseOrderDetail"
								@resetMethod="resetModal" @uploadButtonMethod="uploadDataPurchaseOrderDetail"
								:parentId="modelId" />
						</template>
						<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPurchaseOrderDetailPage"
				:total-rows="totalPurchaseOrderDetailRow"
				:per-page="purchaseOrderDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
					</app-table-input>
				</b-col>

			</b-row>
		</b-card>

		<b-card header="Summary" class="mb-3">
			<b-row>
				<b-col cols="6" lg="3">
					<p class="mt-2">Total Qty</p>
					<p class="mt-2">Total Amount</p>
				</b-col>
				<b-col cols="6" lg="3">
					<app-input-textbox :id="'input-purchase-order-total-qty'" label="Total Amount" size="sm"
						:thousandSeparator="true" :model.sync="model.totalQty" :state="validateState('totalQty')"
						:errorMessage="getErrorMessage(errorMessage.totalAmount, 'totalQty')" :isEditable="false"
						:nolabel="true" />
					<app-input-textbox :id="'input-purchase-order-total-amount'" label="Total Amount" size="sm"
						:thousandSeparator="true" :model.sync="model.totalAmount" :state="validateState('totalAmount')"
						:errorMessage="getErrorMessage(errorMessage.totalAmount, 'totalAmount')" :isEditable="false"
						:nolabel="true" />
				</b-col>
			</b-row>
		</b-card>

		<b-card class="mb-3">
			<b-row>
				<b-col cols="12" lg="12">
					<app-table-input 
			title="PO Attachment"
			:bordered="true" :items="purchaseOrderAttachments" 
			:fields="fieldsPurchaseOrderAttachment" 
			:busy="isDataLoading" 
			:sort-by.sync="sortByPurchaseOrderAttachment" 
			:sort-desc.sync="sortDescPurchaseOrderAttachment" small responsive	
			@editButtonMethod="editRowDataPurchaseOrderAttachment"	
			@deleteButtonMethod="deleteRowDataPurchaseOrderAttachment"	
			@showPopupAddMethod="addDataPurchaseOrderAttachment()"	
			@showPopupUploadMethod="showPopupUploadPurchaseOrderAttachment()"
			@downloadMethod="downloadPurchaseOrderAttachment()"
			@addFromClipboardMethod="addFromClipboardPurchaseOrderAttachment()"
			@replaceFromClipboardMethod="replaceFromClipboardPurchaseOrderAttachment()"
			:showActionButton="true"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"	
			:showReplaceFromClipboardButton="false"	
			:showUploadButton="false"	
			:showDownloadButton="false"	
			:isDownloadBusy="isDownloadPurchaseOrderAttachment"
		>
								
			<!-- <template v-slot:head(actions)>
				<b-button @click="isShowPurchaseOrderAttachmentFilter = !isShowPurchaseOrderAttachmentFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template> -->
								
			<template #top-row v-if="isShowPurchaseOrderAttachmentFilter">
				<b-th></b-th>
				<b-th stacked-heading="Attachment">
				</b-th>
				<b-th stacked-heading="Remarks">
					<b-form-input id="input-table-purchase-order-attachment-remarks-table" v-model="filterPurchaseOrderAttachment.remarks" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
								
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( purchaseOrderAttachmentPageSize * (currentPurchaseOrderAttachmentPage - 1))) }}
			</template>
								
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
								
			<template v-slot:cell(poAttachment)="row">
				<app-input-fileupload :id="'input-table-purchase-order-attachment-' + row.index" label-cols-lg="12" label="Attachment" size="sm" :model.sync="poAttachments[row.item.id]" :currentModel="row.item.poAttachment" @change="saveInputPurchaseOrderAttachment(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>
			<template v-slot:cell(remarks)="row">
				<app-input-textarea :id="'input-table-purchase-order-attachment-remarks-' + row.index" label-cols-lg="12" label="Remarks" size="sm" :model.sync="row.item.remarks"  @change="saveInputPurchaseOrderAttachment(row.item)" :isUpdatable ="null"  :nolabel="true" />
			</template>

								
			<!-- <template v-slot:form-add-detail>
				<PurchaseOrderAttachmentInput 
					:model="modelPurchaseOrderAttachment"
					:openPopup="isShowPopupPurchaseOrderAttachment"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataPurchaseOrderAttachment"/>
			</template>
			<template v-slot:upload-detail>
					<PurchaseOrderAttachmentUpload
					:openPopup="isShowPopupUploadPurchaseOrderAttachment"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataPurchaseOrderAttachment"
					:parentId="modelId"
					/>
			</template> -->
			<!-- <template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentPurchaseOrderAttachmentPage"
				:total-rows="totalPurchaseOrderAttachmentRow"
				:per-page="purchaseOrderAttachmentPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template> -->
		</app-table-input>
				</b-col>

			</b-row>
		</b-card>

		<template #modal-left-button v-if="this.model.statusId === 'REQUEST FOR REVISION'">
			<b-overlay :show="isBusy" rounded opacity="0.6" spinner-small spinner-variant="primary"
				class="float-right mr-2">
				<b-button @click="resubmitAction()" size="sm" class="float-right btn-default">
					Resubmit Request
				</b-button>
			</b-overlay>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterViewApprovalDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PurchaseOrder from '@/models/PurchaseOrder/PurchaseOrder';
import PurchaseOrderList from '@/models/PurchaseOrder/PurchaseOrderList';
import PurchaseOrderFilter from '@/filters/PurchaseOrder/PurchaseOrderFilter';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PurchaseRequest from '@/models/PurchaseRequest/PurchaseRequest';
import PurchaseRequestFilter from '@/filters/PurchaseRequest/PurchaseRequestFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import AppInputTextarea from '@/components/AppInputTextarea';
import Vendor from '@/models/Vendor/Vendor';
import VendorFilter from '@/filters/Vendor/VendorFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextboxCustom from '@/components/AppInputTextboxCustom';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import Part from '@/models/Part/Part';
import PartClassification from '@/models/PartClassification/PartClassification';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PurchaseOrderDetailInput from '@/views/PurchaseOrder/PurchaseOrderDetailInput';
import PurchaseOrderDetailUpload from '@/views/PurchaseOrder/PurchaseOrderDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
import PopupRouterViewApprovalDetail from '@/components/PopupRouterViewApprovalDetail';
import PurchaseOrderAttachment from '@/models/PurchaseOrder/PurchaseOrderAttachment';
import PurchaseOrderAttachmentFilter from '@/filters/PurchaseOrder/PurchaseOrderAttachmentFilter';
import AppInputFileupload from '@/components/AppInputFileupload';

const validateDate = function (input) {
	if (input < this.model.purchaseOrderDate) {
		return false;
	}
	return true;
}

export default {
	components: {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextarea,
		AppInputTextbox,
		AppInputTextboxCustom,
		PurchaseOrderDetailInput, PurchaseOrderDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewApprovalDetail,
		PopupRouterView,
		AppInputFileupload,
	},
	mixins: [validationMixin],
	validations: {
		model: {
			//purchaseRequestNumber: { required },
			//purchaseOrderDate: { required },
			deliveryDateRequest: { validateDate },
			vendorId: { required },
			//priceUnit: { required }
		},
	},
	data() {
		return {
			errorMessage: {
				//purchaseRequestNumber: { required: "Purchase Request Number is required" },
				//purchaseOrderDate: { required: "Purchase Order Date is required" },
				deliveryDateRequest: { validateDate: "Tanggal Delivery harus lebih besar dari tanggal hari ini dan tidak boleh lebih kecil dari Tanggal PO" },
				vendorId: { required: "Vendor is required" },
				//priceUnit: { required: "Price is required" }
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPurchaseOrderDetail: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "part": { "class": "th-part first-child", "label": "Part Code", key: 'part', sortable: false } },
				{ "partName": { "class": "th-part-name", "label": "Part Name", key: 'partName', sortable: false } },
				{ "qtyPo": { "class": "th-qty-po last-child", "label": "Qty PO", key: 'qtyPo', sortable: false } },
				{ "uomPo": { "class": "th-uomPo d-stack-none", "label": "Uom Po", key: 'uomPo', sortable: false } },
				{ "priceUnit": { "class": "th-price-unit d-stack-none", "label": "Price (Rp/Unit)", key: 'priceUnit', sortable: false } },
				{ "subtotal": { "class": "th-subtotal d-stack-none", "label": "Subtotal (Rp)", key: 'subtotal', sortable: false } },
				{ "pricePpn": { "class": "th-price-ppn d-stack-none", "label": "Ppn", key: 'pricePpn', sortable: false } },
				{ "amount": { "class": "th-amount d-stack-none", "label": "Amount", key: 'amount', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fieldsPurchaseOrderAttachment: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"poAttachment": { "class" : "th-po-attachment first-child", "label" : "Attachment", key: 'poAttachment', sortable: false}}, 
				{"remarks": { "class" : "th-remarks", "label" : "Remarks", key: 'remarks', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			modelPurchaseOrderAttachment : {},
			isShowPopupPurchaseOrderAttachment : false,
			isShowPopupUploadPurchaseOrderAttachment : false,
			filterPurchaseOrderAttachment : null,
			currentPurchaseOrderAttachmentPage : 1,
			purchaseOrderAttachmentPageSize: 10,
			sortByPurchaseOrderAttachment: '',
			sortDescPurchaseOrderAttachment: '',
			sortingByPurchaseOrderAttachment: [],
			purchaseOrderAttachments : [],
			purchaseOrderAttachmentId : '',
			totalPurchaseOrderAttachmentRow : 0,
			isShowPurchaseOrderAttachmentFilter: false,
			isDownloadPurchaseOrderAttachment: false,
			poAttachments: [],
			isAttachmentComboLoading: false,
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPurchaseOrderDetail: {},
			isShowPopupPurchaseOrderDetail: false,
			isShowPopupUploadPurchaseOrderDetail: false,
			filterPurchaseOrder: null,
			currentPurchaseOrderPage: 1,
			purchaseOrderPageSize: 10,
			sortByPurchaseOrder: '',
			sortDescPurchaseOrder: '',
			filterPurchaseOrderDetail: null,
			currentPurchaseOrderDetailPage: 1,
			purchaseOrderDetailPageSize: 10,
			sortByPurchaseOrderDetail: '',
			sortDescPurchaseOrderDetail: '',
			sortingByPurchaseOrderDetail: [],
			purchaseOrderDetails: [],
			purchaseOrderDetailId: '',
			totalPurchaseOrderDetailRow: 0,
			isShowPurchaseOrderDetailFilter: false,
			isDownloadPurchaseOrderDetail: false,
			parts: [],
			purchaseRequests: [],
			purchaseRequests: [],
			isPurchaseRequestComboLoading: false,
			vendors: [],
			vendors: [],
			isVendorComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			backroute: '',
			isPurchaseRequestComboLoading: false,
			isVendorComboLoading: false,
			isPartComboLoading: false,
			isPurchaseOrderComboLoading: false,
			minDate: new Date(),
			purchaseOrderNumber: '',
		}
	},
	methods: {
		ValidateFileSize(attachment) {
			let size = 2 * 1024 * 1024;
			if (attachment.size > size) {
				return "File size tidak boleh lebih dari 2mb";
			}

			return "";
		},
		ValidateFileFormat(attachment) {
			let formatValid = ["jpeg", "jpg", "svg", "png", "pdf", "xlsx"];

			let formatFile = attachment.name.split('.').pop();
			if (!formatValid.includes(formatFile)) {
				return "Format file yang boleh hanya image, excel dan PDF";
			}
			return "";
		},
		showAlert(errorMessage) {
			const msg = this.$createElement;
			const msgNode = msg('div', {
				domProps: {
					innerHTML: `<p>${errorMessage}</p>`
				}
			});
			this.$bvModal.msgBoxOk([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				// cancelVariant: 'danger',
				okTitle: 'Ok',
				// cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			});
		},
		getPurchaseOrderAttachments : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseOrderAttachment);
			if (this.modelId == null) return;
			filter.purchaseOrderId = this.modelId;
			//filter.draftMode = "1";
			if (this.sortByPurchaseOrderAttachment != null) {
				this.sortingByPurchaseOrderAttachment[this.sortByPurchaseOrderAttachment] = this.sortDescPurchaseOrderAttachment;
			}
			let currentPage = (this.currentPurchaseOrderAttachmentPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseOrderAttachmentRow + 1;
				let page = Math.ceil(totalData/this.purchaseOrderAttachmentPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseOrderAttachmentPageSize = 0;
			// disable paging end
			PurchaseOrderAttachment.getList(this, filter, this.sortingByPurchaseOrderAttachment, currentPage , this.purchaseOrderAttachmentPageSize).then(async result => {
				this.currentPurchaseOrderAttachmentPage = currentPage + 1;
				this.purchaseOrderAttachments = result.data;
				this.totalPurchaseOrderAttachmentRow = result.dataCount;
				this.poAttachments = Array();
				for(var item of result.data) {
					if (item.poAttachmentId) {
						let type = 'plain/txt';
						this.poAttachments[item.id] = new File([await fetch(item.poAttachment.downloadUrl).then(r => r.blob())], item.poAttachment.originalFilename, { type: type });
					}
				}

			}).catch(error => {});
		},
		getAttachments : async function(input) {
			let filter = new AttachmentFilter();
			if (input != undefined) {
				filter.originalFilename = input;
			}
			this.isAttachmentComboLoading = true;
			Attachment.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.attachments = result.data
				}
				this.isAttachmentComboLoading = false;
			})
			.catch(error => {});
		},
		addRowDataPurchaseOrderAttachment(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseOrderId =  this.modelId;
					PurchaseOrderAttachment.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getPurchaseOrderAttachments(true);
						this.isShowPopupPurchaseOrderAttachment = false;
					})
				} else {
					model.purchaseOrderId =  this.modelId;
					PurchaseOrderAttachment.createDataDetail(this, model)
					.then(result => {
						this.getPurchaseOrderAttachments(true);
						this.isShowPopupPurchaseOrderAttachment = false;
					})
				}
			}
		},
		async editRowDataPurchaseOrderAttachment(id) {
			this.purchaseOrderAttachmentId = id;
			this.isShowPopupPurchaseOrderAttachment = true; 
		},
		async deleteRowDataPurchaseOrderAttachment(id) {
			PurchaseOrderAttachment.deleteData(this, id).then(result => { this.getPurchaseOrderAttachments(); });
		},
		async resetDataPurchaseOrderAttachment() {
			this.purchaseOrderAttachmentId = "";
			this.isShowPopupPurchaseOrderAttachment = true;
		},
		async addDataPurchaseOrderAttachment() {
			PurchaseOrderAttachment.createData(this, { purchaseOrderId: this.modelId })
			.then(result => {
				this.getPurchaseOrderAttachments(true);
			})
		},
		async addFromClipboardPurchaseOrderAttachment() {
			let remarkss = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					remarkss.push({ remarks: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderAttachment.addFromClipboard(this, remarkss).then(result => { this.getPurchaseOrderAttachments() });
			});
		},
		async replaceFromClipboardPurchaseOrderAttachment() {
			let remarkss = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					remarkss.push({ remarks: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderAttachment.replaceFromClipboard(this, remarkss).then(result => { this.getPurchaseOrderAttachments() });
			});   
		},
		showPopupUploadPurchaseOrderAttachment() {
			if(this.purchaseOrderAttachments != null && this.purchaseOrderAttachments.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PurchaseOrderAttachment akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadPurchaseOrderAttachment = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadPurchaseOrderAttachment = true;
			}
		},
		uploadDataPurchaseOrderAttachment(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseOrderAttachment = false; 
		},
		downloadPurchaseOrderAttachment(modalEvent) {
			this.isDownloadPurchaseOrderAttachment = true;
			this.filterPurchaseOrderAttachment.purchaseOrderId = this.modelId;
			PurchaseOrderAttachment.downloadDataDetail(this, this.filterPurchaseOrderAttachment).then(result => {
				this.isDownloadPurchaseOrderAttachment = false;
			}).catch(error => { this.isDownloadPurchaseOrderAttachment = false; })
		},
		saveInputPurchaseOrderAttachment(item) {

			let id = item.id;
			let promises = Array();
			if (this.poAttachments[id] != null) {
				let data = new FormData();
				data.append('file', this.poAttachments[id]);
				let _this = this;
				let resultValidateSize = this.ValidateFileSize(this.poAttachments[id]);
				let resultValidateFormat = this.ValidateFileFormat(this.poAttachments[id]);
				if (resultValidateSize != "" || resultValidateFormat != "") {
					let errorMessage = resultValidateFormat != "" ? resultValidateFormat : "";
					if (errorMessage != null || errorMessage != "") {
						errorMessage += "<br />";
					}

					errorMessage += resultValidateSize != "" ? resultValidateSize : "";
					this.poAttachments[id] = null;
					this.showAlert(errorMessage);
					return;
				}
				promises.push(this.$http.post('attachment/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								item.poAttachmentId = response.data.id;
								item.poAttachment = response.data;
							}
						}
						return true;
					})
					.catch(error => {
						this.$store.dispatch('addErrorMessageGlobal', error);
						throw error;
					}));
			} else {
				item.poAttachmentId = null;
				item.poAttachment = null;
				this.poAttachments[id] = null;
			}


			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PurchaseOrderAttachment.updateData(this, item, item.id);
				}
			});
		},
		async updateDeliveryDate() {
			console.log("trigger update delivery date");
			await this.updateData();
			await this.generatePoDetail(null, "UPDATE");
		},
		resubmitAction(modelEvent) {
			let model = this.model;
			let id = this.modelId;
			if (id != '' && id != null && id != undefined) {
				this.isBusy = true;
				PurchaseOrder.resubmitApprovalData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'purchaseorderinbox' });
					this.$emit("successAction");
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		recalculateSummary: async function (item) {
			if (item == undefined) {
				await this.updateData();
				await PurchaseOrder.recalculateSummary(this, this.modelId);
			} else {
				await this.saveInputPurchaseOrderDetail(item);
				await PurchaseOrder.recalculateSummary(this, this.modelId);
			}
			this.getPurchaseOrder(this.modelId);
		},
		getPurchaseOrder: async function (id) {
			this.isBusy = true;
			PurchaseOrder.getData(this, id).then(result => {
				this.model = result;
				this.modelId = result.id;
				this.mainRecordId = String(result.mainRecordId);
				this.purchaseOrderNumber = result.purchaseRequest != null ? result.purchaseRequest.purchaseOrderNumber : "";
				let promises = Array();
				this.getPurchaseOrderDetails(null);
				this.getPurchaseOrderAttachments(null);
				if (this.model.vendorId != null) {
					promises.push(
						this.getVendor(this.model.vendorId).then(result => {
							return true;
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}
				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadPurchaseOrder = true;
			this.filterPurchaseOrder.id = this.modelId;
			PurchaseOrder.downloadDataDetail(this, this.filterPurchaseOrder).then(result => {
				this.isDownloadPurchaseOrder = false;
			}).catch(error => { this.isDownloadPurchaseOrder = false; })
		},
		getPurchaseOrderDetails: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPurchaseOrderDetail);
			if (this.modelId == null) return;
			filter.purchaseOrderId = this.modelId;
			//filter.draftMode = "1";
			if (this.sortByPurchaseOrderDetail != null) {
				this.sortingByPurchaseOrderDetail[this.sortByPurchaseOrderDetail] = this.sortDescPurchaseOrderDetail;
			}
			let currentPage = (this.currentPurchaseOrderDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalPurchaseOrderDetailRow + 1;
				let page = Math.ceil(totalData / this.purchaseOrderDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.purchaseOrderDetailPageSize = 0;
			// disable paging end
			PurchaseOrderDetail.getList(this, filter, this.sortingByPurchaseOrderDetail, currentPage, this.purchaseOrderDetailPageSize).then(result => {
				this.currentPurchaseOrderDetailPage = currentPage + 1;
				this.purchaseOrderDetails = result.data;
				this.totalPurchaseOrderDetailRow = result.dataCount;

				this.purchaseOrderDetails.forEach(async data => {
					if (data == null || data.part == null) return;

					if (data.part.partClassificationId != null) {
						if (data.part.partClassification.code.toUpperCase() == "RM" || data.part.partClassification.code.toUpperCase() == "COMPONENT") {
							data.part.partName = data.part.partSpecification;
						} else {
							data.part.partName = data.part.partName;
						}
					} else {
						data.part.partName = "";
					}
				});
			}).catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.PurchaseOrderNumber = input;
			}
			this.isPurchaseOrderComboLoading = true;
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
					this.isPurchaseOrderComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseOrders: async function (input) {
			let filter = new PurchaseOrderFilter();
			if (input != undefined) {
				filter.purchaseOrderNumber = input;
			}
			this.isPurchaseOrderComboLoading = true;
			PurchaseOrder.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseOrders = result.data
					}
					this.isPurchaseOrderComboLoading = false;
				})
				.catch(error => { });
		},
		getPurchaseRequests: async function (input) {
			let filter = new PurchaseRequestFilter();
			if (input != undefined) {
				filter.purchaseRequestNumber = input;
			}
			filter["purchaseRequestStatusId"] = "OPEN";
			PurchaseRequest.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.purchaseRequests = result.data
					}
				})
				.catch(error => { });
		},
		async checkExistingPoDraftByPRId(item)
		{
			if(item == null || item.id == null) return false;	
			let filter = new PurchaseOrderFilter();
			filter.purchaseRequestId = item.id;
			filter.statusId = "DRAFT";
			let purchaseOrders = await PurchaseOrder.getMySubmissionList(this, filter, null, 0, 1);
			if(purchaseOrders != null && purchaseOrders.data.length > 0)
			{
				let id = purchaseOrders.data[0].id;
				this.$router.replace('/purchaseorder/createinboxrequest/' + id, () => {
					this.getPurchaseOrder(id);
				});
				return true;
			}
			return false;
		},
		async updatePurchaseRequest(item) {
			if (this.model.vendorId == null) {
				this.isBusy = true;
				let isReplaced = await this.checkExistingPoDraftByPRId(item);
				if(isReplaced == false) {
					await this.setSelectedPurchaseRequest(item);
					await this.getVendors(null);
					await this.setSelectedVendor(null);
				}
				this.isBusy = false;
			} else {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Apakah anda yakin ingin merubah PR Number? Data Vendor, data Purchase Order Detail, dan data PO Attachment akan direload.</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(async e => {
					if (e) {
						this.isBusy = true;
						let isReplaced = await this.checkExistingPoDraftByPRId(item);
						if(isReplaced == false) {
							await this.setSelectedPurchaseRequest(item);
							await this.getVendors(null);
							await this.setSelectedVendor(null);
						}
						this.isBusy = false;
					} else {
						return;
					}
				});
			}
		},
		async updateVendor(item) {
			if (!this.model.vendorId) {
				this.isBusy = true;
				await this.setSelectedVendor(item);
				this.isBusy = false;
			} else {
				const msg = this.$createElement;
				let msgNode = '';
				msgNode = msg('div', { domProps: { innerHTML: '<p>Apakah anda yakin ingin merubah Vendor? Data pada tabel Purchase Order Detail akan di-buat ulang dan data pada tabel PO Attachment akan dihapus</p>' } })
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Alert',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'secondary',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				}).then(async e => {
					if (e) {
						this.isBusy = true;
						await this.setSelectedVendor(item);
						this.isBusy = false;
					} else {
						return;
					}
				});
			}
		},
		async setSelectedPurchaseRequest(item) {
			if (item == undefined || item == null) {
				this.model.deliveryDateRequest = null;
				this.model.purchaseRequestId = null;
				this.model.purchaseRequest = null;
			} else {
				this.model.purchaseRequestId = item.id;
				this.model.purchaseRequest = item;
				this.model.deliveryDateRequest = item.deliveryDate;
			}
			this.$forceUpdate();
			await this.updateData();
		},
		getVendors: async function (input) {
			if (!this.model.purchaseRequestId) {
				this.vendors = [];
				return;
			}
			let filter = new VendorFilter();
			if (input != undefined) {
				filter.code = input;
			}
			await Vendor.getByPurchaseRequisition(this, this.model.purchaseRequestId, filter, null, 0, 10)
				.then(result => {
					this.vendors = result.data;
				})
				.catch(error => { });
		},
		async generatePoDetail(id, prefix) {
			try {
				let id_ = id == null || id == undefined ? this.modelId : id;
				await PurchaseOrder.generatePurchaseOrderDetails(this, id_, prefix);
				this.getPurchaseOrder(id_);
			} catch { this.isBusy = false; }
		},
		async setSelectedVendor(item) {
			if (item == undefined || item == null) {
				this.model.vendorId = null;
				this.model.vendor = null;
			} else {
				this.model.vendorId = item.id;
				this.model.vendor = item;
			}
			this.$forceUpdate();
			await this.updateData();
			await this.generatePoDetail(null, "CREATE");
		},
		getVendor: async function (id) {
			Vendor.getData(this, id).then(result => {
				this.model.vendor = result;
				this.isBusy = false;
				return result;
			}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
			if (this.$v.model[name].validateDate != undefined && !this.$v.model[name].validateDate) {
				if (message.validateDate) return message.validateDate;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			// if (this.totalPurchaseOrderDetailRow == null || this.totalPurchaseOrderDetailRow == 0) {
			// 	let error = "Purchase order detail is required";
			// 	this.$store.dispatch('addErrorMessageGlobal', error);
			// 	this.isBusy = false;
			// 	throw error;
			// }

			if (id != '' && id != null && id != undefined) {
				model.statusId = 'DRAFT';
				PurchaseOrder.updateData(this, model, id).then(result => {
					PurchaseOrder.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaseorderinbox' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}).catch(error => { this.isBusy = false; });
			} else {
				model.statusId = 'DRAFT';
				PurchaseOrder.insertData(this, model).then(result => {
					this.$router.push({ name: 'purchaseorderinbox' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		submitAction(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;
				if (id != '' && id != null && id != undefined) {
					PurchaseOrder.submitApprovalData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'purchaseorderinbox' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();
			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PurchaseOrder.updateData(this, model, id)
						.catch((error) => {
							this.getPurchaseOrder(id);
						});
				}
			});
		},
		onHidden() {
			this.getPurchaseOrders();
		},
		addRowDataPurchaseOrderDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.purchaseOrderId = this.modelId;
					PurchaseOrderDetail.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPurchaseOrderDetails(true);
							this.isShowPopupPurchaseOrderDetail = false;
						})
				} else {
					model.purchaseOrderId = this.modelId;
					PurchaseOrderDetail.createDataDetail(this, model)
						.then(result => {
							this.getPurchaseOrderDetails(true);
							this.isShowPopupPurchaseOrderDetail = false;
						})
				}
			}
		},
		async editRowDataPurchaseOrderDetail(id) {
			this.purchaseOrderDetailId = id;
			this.isShowPopupPurchaseOrderDetail = true;
		},
		async deleteRowDataPurchaseOrderDetail(id) {
			PurchaseOrderDetail.deleteData(this, id).then(result => { this.getPurchaseOrderDetails(); });
		},
		async resetDataPurchaseOrderDetail() {
			this.purchaseOrderDetailId = "";
			this.isShowPopupPurchaseOrderDetail = true;
		},
		async addDataPurchaseOrderDetail() {
			PurchaseOrderDetail.createData(this, { purchaseOrderId: this.modelId })
				.then(result => {
					this.getPurchaseOrderDetails(true);
				})
		},
		async addFromClipboardPurchaseOrderDetail() {
			let qtyPos = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					qtyPos.push({ qtyPo: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderDetail.addFromClipboard(this, qtyPos).then(result => { this.getPurchaseOrderDetails() });
			});
		},
		async replaceFromClipboardPurchaseOrderDetail() {
			let qtyPos = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					qtyPos.push({ qtyPo: item, purchaseOrderId: this.modelId });
				});
				PurchaseOrderDetail.replaceFromClipboard(this, qtyPos).then(result => { this.getPurchaseOrderDetails() });
			});
		},
		showPopupUploadPurchaseOrderDetail() {
			if (this.purchaseOrderDetails != null && this.purchaseOrderDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap PurchaseOrderDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
					.then(value => {
						if (value) {
							this.isShowPopupUploadPurchaseOrderDetail = true;
						}
					})
					.catch(err => { })
			} else {
				this.isShowPopupUploadPurchaseOrderDetail = true;
			}
		},
		uploadDataPurchaseOrderDetail(modalEvent, newDatas) {
			this.isShowPopupUploadPurchaseOrderDetail = false;
		},
		downloadPurchaseOrderDetail(modalEvent) {
			this.isDownloadPurchaseOrderDetail = true;
			this.filterPurchaseOrderDetail.purchaseOrderId = this.modelId;
			PurchaseOrderDetail.downloadDataDetail(this, this.filterPurchaseOrderDetail).then(result => {
				this.isDownloadPurchaseOrderDetail = false;
			}).catch(error => { this.isDownloadPurchaseOrderDetail = false; })
		},
		saveInputPurchaseOrderDetail(item) {
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.purchaseOrders != null && this.purchaseOrders != undefined && this.purchaseOrders.length > 0) {
				item.purchaseOrder = this.purchaseOrders.find(q => q.id == item.purchaseOrderId);
			}

			let id = item.id;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PurchaseOrderDetail.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPurchaseOrderDetail = false; 
			this.isShowPopupPurchaseOrderDetail = false; 
			if (modalType == 'PurchaseOrderDetail') {
				this.getPurchaseOrderDetails();
			}
			this.isShowPopupUploadPurchaseOrderAttachment = false; 
			this.isShowPopupPurchaseOrderAttachment = false; 
			if (modalType == 'PurchaseOrderAttachment') {
				this.getPurchaseOrderAttachments();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				//this.isShowPurchaseOrderDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterPurchaseOrder = new PurchaseOrderFilter();
		this.filterPurchaseOrderDetail = new PurchaseOrderDetailFilter();
		this.filterPurchaseOrderAttachment = new PurchaseOrderAttachmentFilter();
		//this.getParts();
		//this.getPurchaseOrders();
		//this.getPurchaseRequests();
		//this.getVendors();
	},
	async mounted() {
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				await this.generatePoDetail(id,"UPDATE");
			} else {
				this.modelId = id;
				await this.generatePoDetail(id,"CREATE");
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isEditRequest: {
			get: function () {
				if (this.model.mainRecordId || this.model.statusId == "REQUEST FOR REVISION") {
					return false;
				}
				return true;
			}
		},
		isAllowSaveDraft: {
			get: function () {
				if (this.model.statusId == "REQUEST FOR REVISION" || this.model.mainRecordId != null) {
					return false;
				}
				return true;
			}
		},
		isAllowSubmit: {
			get: function () {
				if (this.model.statusId == "REQUEST FOR REVISION") {
					return false;
				}
				return true;
			}
		}
	},
	watch: {
		sortByPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		sortDescPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		currentPurchaseOrderDetailPage: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		purchaseOrderDetailPageSize: {
			handler: function () {
				this.getPurchaseOrderDetails();
			}
		},
		filterPurchaseOrderDetail: {
			handler: function () {
				this.getPurchaseOrderDetails();
			},
			deep: true,
		},
		sortByPurchaseOrderAttachment : {
			handler: function() {
				this.getPurchaseOrderAttachments();
			}
		},
		sortDescPurchaseOrderAttachment: {
			handler: function() {
				this.getPurchaseOrderAttachments();
			}
		},
		currentPurchaseOrderAttachmentPage: {
			handler: function() {
				this.getPurchaseOrderAttachments();
			}
		},
		purchaseOrderAttachmentPageSize : {
			handler: function() {
				this.getPurchaseOrderAttachments();
			}
		},
		filterPurchaseOrderAttachment: {
			handler: function() {
				this.getPurchaseOrderAttachments();
			},
			deep: true,
		},
		purchaseOrderNumber(newValue) {
			this.model.purchaseOrderNumber = newValue;
		}
	},
}
</script>
